import React, { useState } from 'react';
import styled from 'styled-components';

const TalkContainer = styled.div`
  max-width: 1200px;
  margin: 40px auto;
  padding: 0 20px;
`;

const PageTitle = styled.h1`
  font-size: 2rem;
  text-align: center;
  margin-bottom: 30px;
  color: #333;
`;

const TalkGrid = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 30px;
  
  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const AstrologersList = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  height: 600px;
  overflow-y: auto;
`;

const FiltersSection = styled.div`
  margin-bottom: 20px;
`;

const FilterTitle = styled.h3`
  font-size: 1.1rem;
  margin-bottom: 10px;
  color: #333;
`;

const FilterOptions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 20px;
`;

const FilterOption = styled.button`
  background-color: ${props => props.active ? '#f9d71c' : '#f5f5f5'};
  color: #333;
  border: none;
  border-radius: 20px;
  padding: 8px 15px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.3s;
  
  &:hover {
    background-color: ${props => props.active ? '#f9d71c' : '#e5e5e5'};
  }
`;

const SearchBox = styled.input`
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-bottom: 20px;
  font-size: 0.9rem;
  
  &:focus {
    outline: none;
    border-color: #f9d71c;
  }
`;

const AstrologerCard = styled.div`
  display: flex;
  padding: 15px;
  border-bottom: 1px solid #eee;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #f9f9f9;
  }
  
  &:last-child {
    border-bottom: none;
  }
`;

const AstrologerAvatar = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const AstrologerInfo = styled.div`
  flex: 1;
`;

const AstrologerName = styled.h4`
  font-size: 1rem;
  margin-bottom: 5px;
  color: #333;
`;

const AstrologerSpecialty = styled.p`
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 5px;
`;

const AstrologerStats = styled.div`
  display: flex;
  gap: 15px;
  font-size: 0.8rem;
  color: #888;
`;

const OnlineStatus = styled.span`
  color: ${props => props.online ? '#4caf50' : '#f44336'};
  font-weight: 500;
`;

const CallInterface = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 600px;
`;

const CallHeader = styled.div`
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
`;

const CallHeaderInfo = styled.div`
  margin-left: 15px;
`;

const CallContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const CallStatus = styled.div`
  text-align: center;
  margin-bottom: 30px;
`;

const CallStatusIcon = styled.div`
  font-size: 5rem;
  margin-bottom: 20px;
  color: ${props => props.status === 'calling' ? '#f9d71c' : 
                    props.status === 'connected' ? '#4caf50' : 
                    props.status === 'ended' ? '#f44336' : '#ddd'};
`;

const CallStatusText = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 10px;
  color: #333;
`;

const CallTimer = styled.div`
  font-size: 1.2rem;
  color: #666;
  margin-bottom: 30px;
`;

const CallControls = styled.div`
  display: flex;
  gap: 20px;
`;

const CallButton = styled.button`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s;
  
  &.call {
    background-color: #4caf50;
    color: white;
    
    &:hover {
      background-color: #3d9c40;
    }
  }
  
  &.end {
    background-color: #f44336;
    color: white;
    
    &:hover {
      background-color: #e53935;
    }
  }
  
  &.mute {
    background-color: ${props => props.active ? '#f9d71c' : '#f5f5f5'};
    color: #333;
    
    &:hover {
      background-color: ${props => props.active ? '#e6c400' : '#e5e5e5'};
    }
  }
`;

const NoAstrologerSelected = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #888;
  text-align: center;
  padding: 20px;
`;

const NoAstrologerIcon = styled.div`
  font-size: 3rem;
  margin-bottom: 20px;
  color: #ddd;
`;

const WalletSection = styled.div`
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-top: 20px;
`;

const WalletTitle = styled.h3`
  font-size: 1.1rem;
  margin-bottom: 10px;
  color: #333;
`;

const WalletBalance = styled.div`
  font-size: 1.5rem;
  font-weight: 500;
  color: #333;
  margin-bottom: 10px;
`;

const RechargeButton = styled.button`
  background-color: #f9d71c;
  color: #333;
  border: none;
  border-radius: 4px;
  padding: 10px 15px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #e6c400;
  }
`;

const TalkToAstrologer = () => {
  const [selectedAstrologer, setSelectedAstrologer] = useState(null);
  const [activeFilter, setActiveFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [callStatus, setCallStatus] = useState('idle'); // idle, calling, connected, ended
  const [isMuted, setIsMuted] = useState(false);
  const [callTime, setCallTime] = useState(0);
  
  // Sample astrologers data
  const astrologers = [
    {
      id: 1,
      name: 'Jayant',
      specialty: 'Vedic Astrology',
      experience: '10 years',
      rating: 4.8,
      online: true,
      avatar: '/astrologer1.jpg',
      pricePerMinute: 20
    },
    {
      id: 2,
      name: 'Parveen',
      specialty: 'Numerology',
      experience: '8 years',
      rating: 4.7,
      online: true,
      avatar: '/astrologer2.jpg',
      pricePerMinute: 15
    },
    {
      id: 3,
      name: 'Dimple',
      specialty: 'Vedic Astrology',
      experience: '12 years',
      rating: 4.9,
      online: false,
      avatar: '/astrologer3.jpg',
      pricePerMinute: 25
    },
    {
      id: 4,
      name: 'Deepaa',
      specialty: 'Vedic Astrology',
      experience: '7 years',
      rating: 4.6,
      online: true,
      avatar: '/astrologer4.jpg',
      pricePerMinute: 18
    },
    {
      id: 5,
      name: 'Rajesh',
      specialty: 'Tarot Reading',
      experience: '9 years',
      rating: 4.5,
      online: true,
      avatar: '/astrologer5.jpg',
      pricePerMinute: 22
    }
  ];
  
  const handleStartCall = () => {
    if (!selectedAstrologer || !selectedAstrologer.online) return;
    
    setCallStatus('calling');
    
    // Simulate connecting after 2 seconds
    setTimeout(() => {
      setCallStatus('connected');
      
      // Start call timer
      const timer = setInterval(() => {
        setCallTime(prevTime => prevTime + 1);
      }, 1000);
      
      // Store timer ID for cleanup
      window.callTimerId = timer;
    }, 2000);
  };
  
  const handleEndCall = () => {
    if (callStatus === 'idle') return;
    
    // Clear timer if exists
    if (window.callTimerId) {
      clearInterval(window.callTimerId);
    }
    
    setCallStatus('ended');
    
    // Reset after 3 seconds
    setTimeout(() => {
      setCallStatus('idle');
      setCallTime(0);
    }, 3000);
  };
  
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };
  
  const calculateCost = () => {
    if (!selectedAstrologer) return 0;
    const minutes = Math.ceil(callTime / 60);
    return minutes * selectedAstrologer.pricePerMinute;
  };
  
  const filteredAstrologers = astrologers.filter(astrologer => {
    const matchesFilter = activeFilter === 'All' || astrologer.specialty === activeFilter;
    const matchesSearch = astrologer.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
                          astrologer.specialty.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesFilter && matchesSearch;
  });
  
  return (
    <TalkContainer>
      <PageTitle>Talk to Astrologer</PageTitle>
      <TalkGrid>
        <div>
          <AstrologersList>
            <FiltersSection>
              <FilterTitle>Specialization</FilterTitle>
              <FilterOptions>
                <FilterOption 
                  active={activeFilter === 'All'} 
                  onClick={() => setActiveFilter('All')}
                >
                  All
                </FilterOption>
                <FilterOption 
                  active={activeFilter === 'Vedic Astrology'} 
                  onClick={() => setActiveFilter('Vedic Astrology')}
                >
                  Vedic Astrology
                </FilterOption>
                <FilterOption 
                  active={activeFilter === 'Numerology'} 
                  onClick={() => setActiveFilter('Numerology')}
                >
                  Numerology
                </FilterOption>
                <FilterOption 
                  active={activeFilter === 'Tarot Reading'} 
                  onClick={() => setActiveFilter('Tarot Reading')}
                >
                  Tarot Reading
                </FilterOption>
              </FilterOptions>
            </FiltersSection>
            
            <SearchBox 
              type="text" 
              placeholder="Search astrologers..." 
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            
            {filteredAstrologers.map(astrologer => (
              <AstrologerCard 
                key={astrologer.id}
                onClick={() => {
                  if (callStatus === 'idle' || callStatus === 'ended') {
                    setSelectedAstrologer(astrologer);
                  }
                }}
              >
                <AstrologerAvatar>
                  <img src={astrologer.avatar} alt={astrologer.name} />
                </AstrologerAvatar>
                <AstrologerInfo>
                  <AstrologerName>{astrologer.name}</AstrologerName>
                  <AstrologerSpecialty>{astrologer.specialty}</AstrologerSpecialty>
                  <AstrologerStats>
                    <span>⭐ {astrologer.rating}</span>
                    <span>{astrologer.experience}</span>
                    <OnlineStatus online={astrologer.online}>
                      {astrologer.online ? '● Online' : '● Offline'}
                    </OnlineStatus>
                  </AstrologerStats>
                  <div style={{ marginTop: '5px', fontSize: '0.9rem' }}>
                    ₹{astrologer.pricePerMinute}/min
                  </div>
                </AstrologerInfo>
              </AstrologerCard>
            ))}
          </AstrologersList>
          
          <WalletSection>
            <WalletTitle>Your Wallet</WalletTitle>
            <WalletBalance>₹500.00</WalletBalance>
            <RechargeButton>Recharge Wallet</RechargeButton>
          </WalletSection>
        </div>
        
        <CallInterface>
          {selectedAstrologer ? (
            <>
              <CallHeader>
                <AstrologerAvatar>
                  <img src={selectedAstrologer.avatar} alt={selectedAstrologer.name} />
                </AstrologerAvatar>
                <CallHeaderInfo>
                  <AstrologerName>{selectedAstrologer.name}</AstrologerName>
                  <AstrologerSpecialty>{selectedAstrologer.specialty}</AstrologerSpecialty>
                </CallHeaderInfo>
              </CallHeader>
              
              <CallContent>
                <CallStatus>
                  <CallStatusIcon status={callStatus}>
                    {callStatus === 'idle' ? '📞' : 
                     callStatus === 'calling' ? '📲' : 
                     callStatus === 'connected' ? '🔊' : '📵'}
                  </CallStatusIcon>
                  <CallStatusText>
                    {callStatus === 'idle' ? 'Ready to Call' : 
                     callStatus === 'calling' ? 'Calling...' : 
                     callStatus === 'connected' ? 'Connected' : 'Call Ended'}
                  </CallStatusText>
                  {callStatus === 'connected' && (
                    <CallTimer>
                      {formatTime(callTime)} (₹{calculateCost()})
                    </CallTimer>
                  )}
                  {callStatus === 'ended' && (
                    <CallTimer>
                      Call duration: {formatTime(callTime)}
                      <br />
                      Total cost: ₹{calculateCost()}
                    </CallTimer>
                  )}
                </CallStatus>
                
                <CallControls>
                  {callStatus === 'idle' && selectedAstrologer.online && (
                    <CallButton className="call" onClick={handleStartCall}>📞</CallButton>
                  )}
                  
                  {(callStatus === 'calling' || callStatus === 'connected') && (
                    <>
                      <CallButton 
                        className="mute" 
                        active={isMuted}
                        onClick={() => setIsMuted(!isMuted)}
                      >
                        {isMuted ? '🔇' : '🔊'}
                      </CallButton>
                      <CallButton className="end" onClick={handleEndCall}>📵</CallButton>
                    </>
                  )}
                </CallControls>
              </CallContent>
            </>
          ) : (
            <NoAstrologerSelected>
              <NoAstrologerIcon>📞</NoAstrologerIcon>
              <h3>Select an astrologer to start a call</h3>
              <p>Choose from our expert astrologers to get personalized guidance</p>
            </NoAstrologerSelected>
          )}
        </CallInterface>
      </TalkGrid>
    </TalkContainer>
  );
};

export default TalkToAstrologer;
